export function reLoadPage() {
    window.location.reload();
}